import React from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  CarouselSlideContent,
  CarouselSlideContentLeft,
  CarouselSlideContentProps,
  CarouselSlideDefinition,
  CarouselSlideTitle,
} from '../carouselCommon';
import {WelcomeCarouselPersonaFormContainer} from './forms/welcomeCarouselPersonaFormContainer';

/*
 * Helpers.
 */

function renderContent(props: CarouselSlideContentProps) {
  const {index, onPreviousClick, onNextClick} = props;

  return (
    <CarouselSlideContent key={index}>
      <CarouselSlideContentLeft>
        <CarouselSlideTitle>
          <Trans id="welcomecarousel-persona-title">Let&apos;s set up your profile</Trans>
        </CarouselSlideTitle>
      </CarouselSlideContentLeft>
      <WelcomeCarouselPersonaFormContainer onPreviousClick={onPreviousClick} onCompleteForm={onNextClick} />
    </CarouselSlideContent>
  );
}

/*
 * Slide defintion.
 */

export const welcomeCarouselPersonaSlide: CarouselSlideDefinition = {
  renderContent,
};
